import React from 'react';
import { Box } from '@mui/material';
import { BulletList, FooterNote, GoalProgressBar, PrimaryButton, ScreenShell, ScreenTitle } from '../parts';
import { ActivityForm } from './ActivityForm';
import { GoalFlowScreenProps } from './types';

/** "Set Your SMART Goal" — the first activity. */
export const StartScreen: React.FC<GoalFlowScreenProps> = ({ goalFlow }) => (
  <ScreenShell
    onClose={goalFlow.requestClose}
    footer={
      <>
        <PrimaryButton onClick={goalFlow.submitForm} disabled={!goalFlow.canSubmit}>
          Add to My Goal
        </PrimaryButton>
        <FooterNote maxActivities={goalFlow.maxActivities} />
      </>
    }
  >
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mb: 2 }}>
      <ScreenTitle>Set Your SMART Goal</ScreenTitle>
      <BulletList>
        <li>
          Let&apos;s get <strong>SPECIFIC</strong> about your goal.
        </li>
        <li>
          This goal is <strong>TIME-BOUND</strong> for the next 4 weeks.
        </li>
        <li>
          Each week, you will <strong>MEASURE</strong> by checking off your activities as you do them.
        </li>
      </BulletList>
    </Box>
    <Box sx={{ mb: 3 }}>
      <GoalProgressBar completed={goalFlow.startProgress} total={goalFlow.maxActivities} />
    </Box>
    <ActivityForm goalFlow={goalFlow} />
  </ScreenShell>
);
